import _ from 'lodash'
import moment from 'moment'
import { addEightHour } from '@/util'
const cancelBtn = { text: '取消预约', type: 'plain', size: 'small', class: ['radius'], id: 'cancel' }
export const calculateTimeout = (time, option = {}) => {
  if (!time) {
    console.error('calculateTimeout "time" 参数错误')
    // throw new Error('calculateTimeout "time" 参数错误')
    return false
  }
  let { type = 'minute', norm = '', differ = 1 } = option
  let normTime = norm ? moment(new Date(norm.replace(/-/g, '/'))) : moment(new Date())
  let date = moment(new Date(time.replace(/-/g, '/'))).diff(normTime, type)
  // console.log('calculateTimeout-->', time, date, date > 1)
  return date > differ
}
//组合OAB列表数据
export const reorganizeListData = data => {
  let listData = data.map(item => {
    let btnData = [
      {
        text: '查看预约详情 >',
        type: 'plain',
        size: 'small',
        class: ['noBorder'],
        path: '/oabDetail',
        id: 'view',
        _data: { ...item, id: item.reservationId }
      }
    ]
    let oabCancelBtn = Object.assign({}, _.clone(cancelBtn), { _data: { ...item, id: item.reservationId } })
    // 10New  等待到达, 20Arrived  已到达, 25Presence  未到店, 30Cancel  已取消
    if (item.status === '10New') {
      let isCanCancel = calculateTimeout(item.cancelTime)
      isCanCancel && btnData.push(oabCancelBtn)
    }

    return {
      datas: item,
      reservationId: item.reservationId,
      createdTime: item.createdTime ? addEightHour(item.createdTime) : '',
      list: [
        { label: '预约经销商：', value: item.dealerName },
        { label: '预约时间：', value: `${item.bookedDate || ''}` },
        { label: '客户信息：', value: `${item.name} ${item.telephone}` },
        { label: '车辆信息：', value: `${item.carModel} | ${item.carPlateNumber}` }
      ],
      btnData
    }
  })
  return listData
}

//组合OAB详情数据
export const reorganizeDetailData = data => {
  let listData = [
    {
      id: 'base',
      text: '订单基本信息',
      list: [
        { label: '订单状态：', value: data.statusDisp },
        { label: '预约编号：', value: data.reservationId },
        { label: '客户信息：', value: `${data.name || ''} ${data.telephone || ''}` },
        { label: '车辆信息：', value: `${data.carModel || ''} | ${data.carPlateNumber || ''}` }
      ]
    },
    {
      id: 'dealer',
      text: '经销商信息',
      list: [
        { label: '经销商名称：', value: data.dealerName },
        { label: '经销商地址：', value: data.dealerAddress },
        { label: '预约时间：', value: `${data.bookedDate || ''} ${data.bookTime || ''}` },
        { label: '备注信息：', value: data.note || '无' },
        { label: '服务类型：', value: getServiceTypeByVal(data?.serviceType) }
      ]
    }
  ]
  let btnData = []
  let oabCancelBtn = Object.assign({}, _.clone(cancelBtn), { _data: { ...data, id: data.reservationId } })
  // 10New  等待到达, 20Arrived  已到达, 25Presence  未到店, 30Cancel  已取消
  if (data.status === '10New') {
    let isCanCancel = calculateTimeout(data.cancelTime)
    isCanCancel && btnData.push(oabCancelBtn)
  }
  return { listData, btnData }
}
const getServiceTypeByVal = val => {
  let key = val ? val.trim() : ''
  let res = '无'
  if (key) {
    res = key
      .split(',')
      .map(type => serviceTypeArr.find(({ id }) => id === type)?.text)
      .join(',')
  }
  return res
}

// 服务类型静态数据
export const serviceTypeArr = [
  { id: '01', text: '保养' },
  { id: '02', text: '机电维修' },
  { id: '03', text: '事故车维修' },
  { id: '05', text: '快修A' },
  { id: '06', text: '快修B' },
  { id: '07', text: '索赔' },
  { id: '08', text: '召回' },
  { id: '09', text: '服务措施' },
  { id: '10', text: '一般维修' },
  { id: '11', text: '喷漆工作' },
  { id: '12', text: '轮胎快修' },
  { id: '13', text: 'PWEI' },
  { id: '14', text: '服务合约' },
  { id: '90', text: '其他' }
]
